import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { SummaryAthleteSelected } from '../components/SummaryAthleteSelected'
import useResponsive from '../hooks/useResponsive'

export function BasicLayoutWithHeader () {
  const lgUp = useResponsive('up', 'lg')

  return (
    <Box marginX={lgUp ? 0 : 1}>
      <SummaryAthleteSelected />
      <Box>
        <Outlet />
      </Box>
    </Box>
  )
}
